import type { Dictionary } from './en'

/* Danish dictionary.
 *
 * Parity quirks carried over from en.ts (see its header):
 *  - feelsUnsafe keeps the TRAILING SPACE;
 *  - markedSafe ends with 💞, no space before it;
 *  - fallbackNameSheet is '- ' (trailing space) vs fallbackNameMap '-';
 *  - historyTitle uses the Danish genitive (bare -s, no apostrophe):
 *    "Sofies aktiveringshistorik";
 *  - timeago mirrors the Dart timeago package's DaMessages
 *    ("for X siden" via prefix+suffix -> composed in suffix());
 *  - km uses the Danish decimal comma ("1,7 km"). */

export const da: Dictionary = {
  brand: 'Heart2Heart',

  landing: {
    tagline:
      'gør det nemmere at vise omsorg og føle sig tryg hvor som helst, når som helst',
    goTestTracking: 'Gå til test-sporing',
  },

  tracking: {
    noAlerts: 'Ingen alarmer fundet',
    markedSafe: (name) =>
      `${name} har markeret sig selv som tryg og er stoppet med at dele sin placering.💞`,
    fallbackName: 'Bruger',
    fallbackNameMap: '-',
    fallbackNameSheet: '- ',
  },

  sheet: {
    activatedRow: (when) => `Heart2Heart aktiveret ${when}`,
    activatedUnknown: '-',
    seeHistory: 'se historik',
    feelsUnsafe: (name) =>
      `${name}, føler sig utryg, lad hende vide, at du er opmærksom `,
    sendReassurance: 'Send beroligelse',
    getDirections: 'Få rutevejledning',
    goBack: 'Tilbage',
    close: 'Luk',
    historyTitle: (name) => `${name}s aktiveringshistorik`,
    historyActivated: (clock) => `Heart2Heart aktiveret ${clock}`,
    historyDeactivated: (clock) => `Heart2Heart deaktiveret ${clock}`,
  },

  toasts: {
    reassuranceSent: 'Beroligelse sendt',
    reassuranceError: 'Der opstod en fejl. Prøv igen.',
    turnOnGeolocation: 'Slå geolokation til for at få rutevejledning.',
    noRouteForType: 'Der er ingen rute for den valgte type. Vælg en anden type.',
  },

  map: {
    alarmActivated: 'Alarm aktiveret',
    loading: 'Indlæser',
    loadingRoute: 'Indlæser rute',
  },

  version: (v) => `v ${v}`,

  authError: (message) => `Fejl: ${message}`,

  /* Dart timeago DaMessages: prefixAgo 'for', suffixAgo 'siden'. */
  timeago: {
    aMoment: 'et øjeblik',
    aMinute: 'et minut',
    minutes: (m) => `${m} minutter`,
    aboutAnHour: 'omkring en time',
    hours: (h) => `${h} timer`,
    aDay: 'en dag',
    days: (d) => `${d} dage`,
    aboutAMonth: 'omkring en måned',
    months: (m) => `${m} måneder`,
    aboutAYear: 'omkring et år',
    years: (y) => `${y} år`,
    suffix: (result) => `for ${result} siden`,
  },

  distance: {
    unknown: '- m',
    meters: (n) => `${n} m`,
    /* Danish decimal comma: "1,7 km". */
    km: (oneDecimal) => `${oneDecimal.replace('.', ',')} km`,
  },
}
